import { defineMessages } from 'react-intl';

export default defineMessages({
  numSinistre: {
    id: 'suivi_sinistre.numero_sinistre',
  },
  dateDeclaration: {
    id: 'suivi_sinistre.date_declaration',
  },
  dateMAJ: {
    id: 'suivi_sinistre.date_MAJ',
  },
  status: {
    id: 'suivi_sinistre.etat',
  },
  immatriculation: {
    id: 'signup_auth_by_contract_success.matriculation',
  },
  modele: {
    id: 'suivi_sinistre.modele',
  },
  sinistre_journale: {
    id: 'suivi_sinistre.suivi_journal_title',
  },
  faireReclamation: {
    id: 'suivi_sinistre.faire_une_reclamation',
  },
  aucunContenu: {
    id: 'suivi_sinistre.aucun_contenu',
  },
});
